import { withTimezoneLabel } from "@utils/datetime";

export enum NotificationTableColumns {
  tenantDisplayName = "tenantDisplayName",
  client = "client",
  applicationName = "applicationName",
  employee = "employee",
  reason = "reason",
  notificationType = "notificationType",
  createdAt = "createdAt",
  resolvedBy = "resolvedBy",
  resolvedAt = "resolvedAt",
}

export const NOTIFICATION_TABLE_COLUMN_LABELS: Record<
  NotificationTableColumns,
  string
> = {
  [NotificationTableColumns.tenantDisplayName]: "Tenant",
  [NotificationTableColumns.client]: "Client",
  [NotificationTableColumns.applicationName]: "Application",
  [NotificationTableColumns.employee]: "Employee",
  [NotificationTableColumns.reason]: "Reason",
  [NotificationTableColumns.notificationType]: "Type",
  [NotificationTableColumns.createdAt]: withTimezoneLabel("Occurred"),
  [NotificationTableColumns.resolvedBy]: "Resolved by",
  [NotificationTableColumns.resolvedAt]: withTimezoneLabel("Resolved at"),
};

export const DEFAULT_ACTIVE_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  NotificationTableColumns,
  boolean
> = {
  [NotificationTableColumns.tenantDisplayName]: true,
  [NotificationTableColumns.client]: true,
  [NotificationTableColumns.applicationName]: true,
  [NotificationTableColumns.employee]: true,
  [NotificationTableColumns.reason]: true,
  [NotificationTableColumns.notificationType]: false,
  [NotificationTableColumns.createdAt]: true,
  [NotificationTableColumns.resolvedBy]: false,
  [NotificationTableColumns.resolvedAt]: false,
};

export const DEFAULT_HISTORY_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  NotificationTableColumns,
  boolean
> = {
  [NotificationTableColumns.tenantDisplayName]: true,
  [NotificationTableColumns.client]: true,
  [NotificationTableColumns.applicationName]: true,
  [NotificationTableColumns.employee]: true,
  [NotificationTableColumns.reason]: true,
  [NotificationTableColumns.notificationType]: false,
  [NotificationTableColumns.createdAt]: true,
  [NotificationTableColumns.resolvedBy]: true,
  [NotificationTableColumns.resolvedAt]: true,
};

export const DEFAULT_NOTIFICATION_TABLE_COLUMN_ORDER: NotificationTableColumns[] =
  [
    NotificationTableColumns.tenantDisplayName,
    NotificationTableColumns.client,
    NotificationTableColumns.applicationName,
    NotificationTableColumns.employee,
    NotificationTableColumns.reason,
    NotificationTableColumns.notificationType,
    NotificationTableColumns.createdAt,
    NotificationTableColumns.resolvedBy,
    NotificationTableColumns.resolvedAt,
  ];

export const getColumnLabels = (): Record<string, string> =>
  NOTIFICATION_TABLE_COLUMN_LABELS;
